module.exports = __webpack_public_path__ + "img/287-2dc8bc.png";